import 'css-chunksrc/client/scenes/calendar/filters/styles.scss';export default {
  "filters": "_filters_191m4_1",
  "title": "_title_191m4_11",
  "row": "_row_191m4_18"
};